import { P2GText } from '@parcel2go/core-ui';

import { PaymentOptionApiModel } from '~/lib/api/smartsend/types';
import ProviderName from '../../../../lib/helpers/ProviderName';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  paymentType: PaymentOptionApiModel;
}

export const PaymentHeader: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GText variant="h5" colour="primary">
      <Trans
        i18nKey="PAYMENT_HEADER"
        t={t}
        values={{
          name: ProviderName(props.paymentType.Provider)
        }}
        defaults="<strong>{{name}} Orders</strong>"
      />
    </P2GText>
  );
};
export default PaymentHeader;
